import request from 'utils/request';
import urls from 'utils/config';

const { API_BASE_URL } = urls || {};

const platformUrl = (path = '') => `${API_BASE_URL}/platform${path}`;

export const fetchPlatformAccess = () =>
  request({
    method: 'get',
    url: platformUrl('/access'),
  });

export const fetchPlatformInstitutions = ({ search = '', page = 0, size = 12 } = {}) =>
  request({
    method: 'get',
    url: platformUrl('/institutions'),
    data: {
      search: search || undefined,
      page,
      size,
    },
  });

export const fetchPlatformInstitution = (orgId) =>
  request({
    method: 'get',
    url: platformUrl(`/institutions/${orgId}`),
  });

export const fetchPlatformAdmins = (orgId, { keyword = '', offset = 0, limit = 10 } = {}) =>
  request({
    method: 'get',
    url: platformUrl(`/institutions/${orgId}/admins`),
    data: {
      keyword: keyword || undefined,
      offset,
      limit,
    },
  });

export const createPlatformSuperAdmin = (orgId, data) =>
  request({
    method: 'post',
    url: platformUrl(`/institutions/${orgId}/super-admins`),
    data,
  });

export const deletePlatformSuperAdmin = (orgId, userId) =>
  request({
    method: 'delete',
    url: platformUrl(`/institutions/${orgId}/super-admins/${userId}`),
  });

export const fetchPlatformOperatorContext = () =>
  request({
    method: 'get',
    url: platformUrl('/operators/context'),
  });

export const fetchPlatformOperators = ({ keyword = '', offset = 0, limit = 10 } = {}) =>
  request({
    method: 'get',
    url: platformUrl('/operators'),
    data: {
      keyword: keyword || undefined,
      offset,
      limit,
    },
  });

export const createPlatformOperator = (data) =>
  request({
    method: 'post',
    url: platformUrl('/operators'),
    data,
  });

export const deletePlatformOperator = (userId) =>
  request({
    method: 'delete',
    url: platformUrl(`/operators/${userId}`),
  });
